/**
 * Global Enums
 */

import type {UIVersion} from "./data/state/AppState";
import {XyiconFeature} from "./generated/api/base";

export enum NavigationEnum {
	HOME = "home",
	BLANK = "blank",
	DETAILS = "details",
	PORTFOLIOS = "portfolios",
	SPACES = "spaces",
	CATALOG = "catalog",
	XYICONS = "xyicons",
	BOUNDARIES = "boundaries",
	REPORTS = "reports",
	REPORT_VIEWS = "report-views",
	SPACE = "space", // space editor
	SETTINGS = "settings",
}

export enum SettingsSubNav {
	PERSONAL = "personal",
	ORGANIZATION = "organization",
	PERMISSIONS = "permissions",
	MODULES = "modules",
}

export enum SettingsModuleNav {
	PORTFOLIO = "portfolio",
	SPACE = "space",
	CATALOG = "catalog",
	XYICON = "xyicon",
	BOUNDARY = "boundary",
}

export enum SettingsModuleSubNav {
	TYPES = "types",
	FIELDS = "fields",
	LAYOUTS = "layouts",
	NAVIGATION = "navigation",
}

export enum SettingsPermissionsSubNav {
	USERS = "users",
	USER_GROUPS = "usergroups",
	PORTFOLIO_GROUPS = "portfoliogroups",
	PERMISSION_SETS = "permissionsets",
}

export enum PermissionSetSubNav {
	PORTFOLIOS = "portfolios",
	SPACES = "spaces",
	XYICONS = "xyicons",
	BOUNDARIES = "boundaries",
}

export const GetOrganizationWideNavigationMenusWithoutSubMenus = (currentUIVersion: UIVersion): NavigationEnum[] => {
	const ret: NavigationEnum[] = [NavigationEnum.PORTFOLIOS, NavigationEnum.CATALOG, NavigationEnum.REPORTS];

	if (currentUIVersion === "5.0") {
		ret.unshift(NavigationEnum.HOME);
	}

	return ret;
};

export const GetOrganizationWideNavigationMenus = (currentUIVersion: UIVersion): NavigationEnum[] => [
	...GetOrganizationWideNavigationMenusWithoutSubMenus(currentUIVersion),
	NavigationEnum.SETTINGS,
];

export const GetPortfolioWideNavigationMenus = (): NavigationEnum[] => [
	NavigationEnum.SPACES,
	NavigationEnum.SPACE,
	NavigationEnum.DETAILS,
	NavigationEnum.XYICONS,
	NavigationEnum.BOUNDARIES,
	NavigationEnum.REPORT_VIEWS,
];

export const GetOrganizationWideViewFeatures = (): XyiconFeature[] => [
	XyiconFeature.Dashboard,
	XyiconFeature.XyiconCatalog,
	XyiconFeature.Portfolio,
	XyiconFeature.Report, // well, we have report-views, which are portfolio-based, but they have the same feature...
];
